import { NumberBox, RadioGroup, TextArea, TextBox } from "devextreme-react";
import { useCallback, useEffect, useState } from "react";
import { useForm } from "react-hook-form";
import { useDispatch, useSelector } from "react-redux";
import { Button } from "../../../../components/buttons";
import { ComboboxNamHoc } from "../../../../components/combobox-namhoc";
import { DefaultPopup } from "../../../../components/modal";
import SearchHocsinh from "../../../../components/search-hocsinh";
import TagboxHinhThucNopBom from "../../../../components/tagbox-hinh-thuc-nop-bom";
import { MinValidateMessage, RequiredMessage } from "../../../../components/validation-message";
import { getDefaultAnimation } from "../../../../helpers/pop-up-animation";
import { sf_hachtoan_congno, sf_hachtoan_congno_viewmodel } from "../../../../models/response/hach-toan-cong-no/sf_hachtoan_congno";
import { ts_hocsinh_viewmodel } from "../../../../models/response/hocsinh/ts_hocsinh";
import { RootState } from "../../../../state/reducers";

type DetailQuyetToanModalProps = {
    title: string,
    sf_hachtoan_congno?: sf_hachtoan_congno_viewmodel,
    onClose: () => void,
    onSubmit: (data: sf_hachtoan_congno) => void,
    is_saving?: boolean,
    animationOf: string,
    nam_hoc?: string
    dm_truong_id?: number,
    ts_hocsinh?: ts_hocsinh_viewmodel,
    con_du?: number,
    sf_mucphaithu_root_id?: number
}

export const DetailQuyetToanModal = (props: DetailQuyetToanModalProps) => {
    const dispatch = useDispatch();
    const { dm_coso_id } = useSelector((x: RootState) => x.common)
    const [formData, setFormData] = useState<sf_hachtoan_congno_viewmodel>(props.sf_hachtoan_congno || {
        id: 0,
        is_da_thanh_toan: false,
        is_hoan_tra: true,
        nam_hoc: props.nam_hoc || "",
        noi_dung: "",
        sf_mucphaithu_id: 0,
        sf_tbtp_id: 0,
        tong_tien: 0,
        ts_hocsinh_id: 0,
        ho_ten: "",
        ma_hs: "",
        ten_he: "",
        ten_khoi: "",
        ten_lop: "",
        ten_truong: "",
        sf_hoanphi_type_id: 0,
        sf_hinhthucnopbom_ids: "1,2,3",
        sf_mucphaithu_root_id: 0,
        dm_coso_id: dm_coso_id
    });
    const animaition = getDefaultAnimation({ of: props.animationOf });
    const { register, formState: { errors }, handleSubmit, trigger, setValue } = useForm<sf_hachtoan_congno_viewmodel>({ mode: "all" });
    const onSubmit = async (data: any) => {
        const isValid = await trigger();
        if (isValid && formData) props.onSubmit(formData)
    }
    const onClose = useCallback(() => {
        window.animationHidePopup(props.animationOf || "")
        setTimeout(() => {
            props.onClose();
        }, 500);
    }, [props.animationOf])
    useEffect(() => {
        if (props.ts_hocsinh) {
            setFormData({
                ...formData,  ts_hocsinh_id: props.ts_hocsinh.id, ho_ten: props.ts_hocsinh.ho_ten, ma_hs: props.ts_hocsinh.ma_hs, ten_he: props.ts_hocsinh.ten_he, ten_khoi: props.ts_hocsinh.ten_khoi, ten_lop: props.ts_hocsinh.ten_lop, ten_truong: props.ts_hocsinh.ten_truong
            })
        }
    }, [props.ts_hocsinh])
    return (
        <DefaultPopup
            // animationOf={props.animationOf}
            maxWidth={400}
            minHeight={250}
            title={props.title}
            onClose={onClose}
        >
            <form onSubmit={handleSubmit(onSubmit)}>
                <div className="pop-up-form">
                    <div className="row">
                        <div className="col-md-12">
                            <div className="form-group">
                                <label className="form-label">Năm học</label>
                                <ComboboxNamHoc
                                    value={formData.nam_hoc}
                                    onValueChanged={(value) => {
                                        setFormData({ ...formData, nam_hoc: value });
                                        trigger("nam_hoc");
                                    }}
                                />
                                <RequiredMessage errors={errors} message="Vui lòng chọn năm học"
                                    name="nam_hoc" register={register} value={formData.nam_hoc} />
                            </div>
                        </div>
                        <div className="col-md-12">
                            <div className="form-group">
                                <label className="form-label">Học sinh</label>
                                {props.ts_hocsinh !== undefined &&
                                    <TextBox
                                        stylingMode='outlined'
                                        value={`${formData.ma_hs} - ${formData.ho_ten}`}
                                    ></TextBox>
                                }
                                {props.ts_hocsinh === undefined &&
                                    <SearchHocsinh
                                        className="search_input"
                                        defaultValue={formData.ho_ten}
                                        onResultChanged={(ts_hocsinh: any) => {
                                            setFormData({ ...formData, ts_hocsinh_id: ts_hocsinh != undefined ? ts_hocsinh.id : formData.ts_hocsinh_id });
                                            setTimeout(() => {
                                                trigger("ts_hocsinh_id")
                                            }, 200)
                                        }}
                                        dm_truong_id={props.dm_truong_id}

                                    />
                                }
                                <MinValidateMessage errors={errors} message="Vui lòng chọn học sinh"
                                    name="ts_hocsinh_id" register={register} value={formData.ts_hocsinh_id} />

                            </div>
                        </div>

                        <div className="col-md-12">
                            <div className="form-group">
                                <label className="form-label">Nội dung</label>
                                <TextArea autoResizeEnabled
                                    stylingMode='outlined'
                                    value={formData.noi_dung}
                                    onValueChanged={(e: any) => {
                                        setFormData({ ...formData, noi_dung: e.value });
                                        setValue('noi_dung', e.value)
                                        trigger("noi_dung");
                                    }}
                                />
                                <RequiredMessage errors={errors} message="Vui lòng điền nội dung"
                                    name="noi_dung" register={register} value={formData.noi_dung} />
                            </div>
                        </div>
                        <div className="col-md-12">
                            <div className="form-group">
                                <label className="form-label">Tổng tiền</label>
                                <NumberBox
                                    stylingMode='outlined'
                                    format={",##0"}
                                    value={formData.tong_tien}
                                    onValueChanged={(e: any) => {
                                        setFormData({ ...formData, tong_tien: e.value });
                                        setValue('tong_tien', e.value)
                                        trigger("tong_tien")
                                    }}
                                />
                                <MinValidateMessage errors={errors} message="Vui lòng điền tổng tiền"
                                    name="tong_tien" register={register} value={formData.tong_tien} />
                            </div>
                        </div>
                        <div className="col-md-12">
                            <div className="form-group">
                                <label className="form-label">Loại</label>
                                <RadioGroup items={["Hoàn trả", "Thu bổ sung"]}
                                    defaultValue={formData.is_hoan_tra == undefined ? null : (formData.is_hoan_tra ? "Hoàn trả" : "Thu bổ sung")}
                                    onValueChanged={(e) => {
                                        setFormData({ ...formData, is_hoan_tra: e.value === "Hoàn trả" });
                                        setValue('is_hoan_tra', e.value)
                                    }}
                                    layout="horizontal"
                                />
                                <MinValidateMessage errors={errors} message="Vui lòng chọn hình thức hoàn trả/ thu bổ sung"
                                    name="tong_tien" register={register} value={formData.tong_tien} />
                            </div>
                        </div>
                        <div className="col-md-12">
                            <div className="form-group">
                                <label className="form-label">Áp dụng cho kỳ nộp</label>
                                <TagboxHinhThucNopBom
                                    value={formData.sf_hinhthucnopbom_ids ? formData.sf_hinhthucnopbom_ids.split(',').map((x) => (parseInt(x) ?? 0)) : []}
                                    onValueChanged={(values) => {
                                        setFormData({ ...formData, sf_hinhthucnopbom_ids: values.join(",") })
                                    }}
                                    dmCoSoId={dm_coso_id}
                                />
                                <RequiredMessage errors={errors} message="Vui lòng chọn kỳ áp dụng"
                                    name="sf_hinhthucnopbom_ids" register={register} value={formData.sf_hinhthucnopbom_ids} />
                            </div>
                        </div>
                    </div>
                </div>
                <div className="pop-up-actions">
                    <Button type="normal" icon="fa fa-times" text="Đóng" onClick={onClose}></Button>{' '}
                    <Button type="normal" icon="fas fa-check-square" isLoading={props.is_saving || false} text={formData.id > 0 ? "Cập nhật" : "Thêm mới"} isSubmitButton={true} onClick={() => { handleSubmit(onSubmit) }}></Button>
                </div>
            </form>
        </DefaultPopup>
    );
}

